import { defineStore } from 'pinia'
import { ref } from 'vue'
import { NotificationList, type Notification } from '@klunkers/shared'
import { api } from '@/api/http'

/** In-app reminders (the same ones that go out as push when configured). */
export const useNotificationsStore = defineStore('notifications', () => {
  const items = ref<Notification[]>([])
  const unread = ref(0)

  async function load() {
    const res = await api('/notifications', { schema: NotificationList })
    items.value = res.notifications
    unread.value = res.unread
  }

  async function markRead(id: string) {
    await api(`/notifications/${id}/read`, { method: 'POST' })
    await load()
  }

  async function markAllRead() {
    await api('/notifications/read-all', { method: 'POST' })
    await load()
  }

  return { items, unread, load, markRead, markAllRead }
})
